/**
 * Enum für Probentypen
 * Wird sowohl im Router als auch in den API-Routen verwendet
 */
export enum Probentyp {
    Probe = 'probe',
    Mustervorlage = 'mustervorlage'
}

/**
 * Hilfsmethoden für Probentyp-Operationen
 */
export class ProbentypHelpers {
    /**
     * Wirft einen standardisierten Fehler für unbekannte Probentypen
     */
    static throwUnbekannterProbentypError(probentyp: Probentyp): never {
        throw new Error(`Unbekannter Probentyp: ${probentyp}`);
    }
}
